import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterStore'
})
export class FilterStorePipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter(it => {
      // let invoice_num = it.invoice_num == null ? "" : it.invoice_num;
      // // let prod_order_id = it.prod_order_id == null ? "" : it.prod_order_id;
      // let prod_order_id = String(it.prod_order_id);
      
      return it.store_name.toLowerCase().includes(searchText.toLowerCase());
      // return it.order_status_name.toLowerCase().includes(searchText.toLowerCase()) ||
      //   it.cust_name.toLowerCase().includes(searchText.toLowerCase()) ||
      //   invoice_num.toLowerCase().includes(searchText.toLowerCase())
      //   ||prod_order_id.toLowerCase().includes(searchText.toLowerCase())
      //   ;
    });
  }

}
